import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import Form from './Form';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import { useQueryMutation } from '@lore/query-connect';
import useNetwork from '../../hooks/useNetwork';
import DESCRIPTION_MAX_LENGTH from './DESCRIPTION_MAX_LENGTH';

export default function Dialog(props) {
  const { supportQuestion } = props;

  const [data, setData] = useState({
    stewardName: '',
    stewardDescription: '',
    stewardEmail: '',
    stewardPhone: '',
    stewardAvatarUrl: '',
    stewardCustomUrl: '',
    stewardCustomLabel: ''
  });
  const [showErrors, setShowErrors] = useState(false);

  const network = useNetwork();

  const mutation = useQueryMutation('networkSupportQuestion.create');
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate({
      ...data,
      networkId: network.id,
      supportQuestionId: supportQuestion.id
    });
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          stewardName: [validators.isRequired],
          stewardDescription: [validators.isRequired, validators.maxLength(DESCRIPTION_MAX_LENGTH)],
          // stewardEmail: [validators.number.isRequired],
          // stewardPhone: [validators.number.isRequired],
          // stewardCustomUrl: [validators.number.isRequired],
          // stewardCustomLabel: [validators.number.isRequired],
          // stewardAvatarUrl: [validators.number.isRequired]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  data={data}
                  onClose={() => {
                    props.onClose();
                    setTimeout(function() {
                      props.onSubmit && props.onSubmit(request)
                    }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Note updated.
                  </SuccessMessage>
                ) : null}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
